import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AnimatedLogo.css';

// Updated cropped logo URLs
const FULL_LOGO_URL = 'https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/06uiebgi_Variant%201_Full%20Logo_Vector%20copy%202.png';
const SHIELD_LOGO_URL = 'https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/ic051cbk_Variant%201_Shield%20Only_Vector%20copy.png';

const AnimatedLogo = ({ variant = 'full', size = 'default' }) => {
  const [isGlowing, setIsGlowing] = useState(false);

  // Trigger glow animation on mount
  useEffect(() => {
    triggerGlow();
  }, []);

  const triggerGlow = () => {
    if (isGlowing) return;
    
    setIsGlowing(true);
    
    // Glow for 1.5 seconds then stop
    setTimeout(() => {
      setIsGlowing(false);
    }, 1500);
  };

  const logoUrl = variant === 'shield' ? SHIELD_LOGO_URL : FULL_LOGO_URL;
  const sizeClass = `logo-size-${size}`;

  return (
    <Link 
      to="/" 
      className={`animated-logo-container ${sizeClass}`}
      onMouseEnter={triggerGlow}
    >
      <img 
        src={logoUrl}
        alt="All Secured Logo" 
        className={`brand-logo ${isGlowing ? 'glowing' : ''}`}
      />
    </Link>
  );
};

export default AnimatedLogo;
